import { Checks } from '@phosphor-icons/react';

export default Checks;
